export default class HttpError extends Error {
  readonly statusCode?: number;
  readonly error?: string;
  readonly serverStack?: string;

  constructor(input: any, statusCode?: number, serverStack?: string) {
    super(input.message || input.error || JSON.stringify(input));

    this.statusCode = input.statusCode || statusCode;
    this.error = input.error;
    this.serverStack = serverStack;
  }
}
